import Form from './Form.vue'
import List from './List.vue'
import View from './View.vue'
import Info from './_info.vue'
import Calendar from './_calendar.vue'
import History from './_history.vue'
import Duplicates from './Duplicates.vue'

const routes = [{
  path: '/client/duplicates',
  component: Duplicates,
  name: 'client/duplicates',
  meta: { roles: ['admin'] }
}, {
  path: '/client/create',
  component: Form,
  name: 'client/create'
}, {
  path: '/client/:clientId/edit',
  component: Form,
  name: 'client/edit'
}, {
  path: '/client/list/:type',
  component: List,
  name: 'client/list',
  meta: { roles: ['admin', 'secretary', 'tehnic'] }
}, {
  path: '/client/:clientId',
  component: View,
  name: 'client/view',
  children: [{
    path: '/client/:clientId/info',
    component: Info,
    name: 'client/view/info',
  }, {
    path: 'calendar',
    component: Calendar,
    name: 'client/view/calendar',
  }, {
    path: 'history',
    component: History,
    name: 'client/view/history',
  }]
}]

export default routes